<template>
  <div class="advert-slot-tabs">
    <el-tabs :value="activeTab" @input="$emit('update:activeTab', $event)" type="border-card">
      <el-tab-pane :label="$t('advert-config.AdvertSlotTabs.767639-0')" name="screenSaver">
        <advert-slot-content
          :adverts="screenSaverAdverts"
          :advert-type-name="screenSaverAdverts.length > 0 ? getAdvertTypeName(screenSaverAdverts[0].type) : ''"
          slot-key="screenSaver"
          :editable="editable"
          @remove="handleRemove"
          @clear="handleClear"
        />
      </el-tab-pane>

      <el-tab-pane :label="$t('advert-config.AdvertSlotTabs.767639-1')" name="topBanner">
        <advert-slot-content
          :adverts="topBannerAdverts"
          :advert-type-name="topBannerAdverts.length > 0 ? getAdvertTypeName(topBannerAdverts[0].type) : ''"
          slot-key="topBanner"
          :editable="editable"
          @remove="handleRemove"
          @clear="handleClear"
        />
      </el-tab-pane>

      <!-- <el-tab-pane :label="$t('advert-config.AdvertSlotTabs.767639-2')" name="externalScreen">
        <advert-slot-content
          :adverts="externalScreenAdverts"
          :advert-type-name="
            externalScreenAdverts.length > 0 ? getAdvertTypeName(externalScreenAdverts[0].type) : ''
          "
          slot-key="externalScreen"
          :editable="editable"
          @remove="handleRemove"
          @clear="handleClear"
        />
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
  import AdvertSlotContent from "./AdvertSlotContent.vue";

  export default {
    name: "AdvertSlotTabs",
    components: {
      AdvertSlotContent
    },
    props: {
      screenSaverAdverts: {
        type: Array,
        default: () => []
      },
      topBannerAdverts: {
        type: Array,
        default: () => []
      },
      externalScreenAdverts: {
        type: Array,
        default: () => []
      },
      activeTab: {
        type: String,
        default: "screenSaver"
      },
      editable: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      getAdvertTypeName(type) {
        const typeMap = {
          0: this.$t("advert-config.AdvertSlotTabs.767639-3"),
          1: this.$t("advert-config.AdvertSlotTabs.767639-4"),
          // 2: this.$t("advert-config.AdvertSlotTabs.767639-5"),
          2: this.$t("advert-config.AdvertSlotTabs.767639-6")
        };
        return typeMap[String(type)] || this.$t("advert-config.AdvertSlotTabs.767639-7");
      },
      handleRemove(slotKey, index) {
        this.$emit("remove", slotKey, index);
      },
      handleClear(slotKey) {
        this.$emit("clear", slotKey);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .advert-slot-tabs {
    height: 100%;

    ::v-deep .el-tabs {
      height: 100%;
      display: flex;
      flex-direction: column;

      .el-tabs__content {
        flex: 1;
        overflow: auto;
      }
    }
  }
</style>
